import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import group from '~src/images/group.png';
import {
  CurrentInfo,
  MainHeader,
  UpToDate,
  SubHeader,
  ProgressContainer,
  ProgressBarInverted,
  ObjectiveProgressContainer,
} from '~src/modules/okrs/objectivesStream/shared.sc';

interface Props {
  name: string;
  progress: number;
  blurOnMobile: boolean;
}

const ObjectiveProgress = memo((props: Props) => {
  const [t] = useTranslation();
  return (
    <ObjectiveProgressContainer $blurOnMobile={props.blurOnMobile}>
      <img src={group} height={160} />
      <CurrentInfo>
        <MainHeader>{props.name}</MainHeader>
        <UpToDate>
          <SubHeader>{t('x.okr.update_stream.objective_updated.objective_up_to_date')}</SubHeader>
        </UpToDate>
        <ProgressContainer>
          {/* add % completed to translations with param */}
          <MainHeader>
            {t('x.okr.update_stream.objective_updated.complete_percentage', {
              progress: props.progress.toString().substr(0, 4),
            })}
          </MainHeader>
          <ProgressBarInverted height={5} width="100%" staticProgress progress={props.progress} />
        </ProgressContainer>
      </CurrentInfo>
    </ObjectiveProgressContainer>
  );
});

export default ObjectiveProgress;
